import '../vendors/advanced-read-more';

/*!
 * jQuery listLimit
 * Copyright (c) ATOM
 */
(function ($) {
  $.fn.linesLimit2 = function (options) {
    var settings = $.extend({

      lines: 4,
      wMin: 0,
      wMax: 99999,
      linkCaption: 'rozwiń...',
      linkCloseCaption: 'zwiń...',
      linkHint: 'więcej',
      linking: false

    }, options);

    return this.each(function () {
      var $this = $(this),
        windowWidth = $(window).width();

      var init = function () {
        $this.addClass('jrm-truncate');

        $this.parent().readMore({
          showLines: settings.lines,
          linkCaption: settings.linkCaption,
          linkCloseCaption: settings.linkCloseCaption,
          linkHint: settings.linkHint,
          linking: settings.linking
        });
      };

      if (windowWidth >= settings.wMin && windowWidth <= settings.wMax) {
        init();

        $this.addClass('lines-limit-init');
      }

      $(window).resize(function () {
        refresh();
      });
    });

  };
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/jquery.plugins/jquery.linesLimit2.js